import React from 'react';
import { Row, Col } from 'antd';
import { ExperimentOutlined, TeamOutlined, BuildOutlined, RiseOutlined, UserOutlined } from '@ant-design/icons';
import './FeaturesSection.scss';
import { useTranslation } from 'react-i18next';

const FeaturesSection = () => {
  // const features = [
  //   {
  //     icon: <ExperimentOutlined className='feature-icon' />,
  //     title: 'Learn by doing approach:',
  //     description: 'Act that our custom program means learned',
  //   },
  //   {
  //     icon: <TeamOutlined className='feature-icon' />,
  //     title: 'Broad stakeholder engagement:',
  //     description: 'All hands-on deck approach created a key team impact',
  //   },
  //   {
  //     icon: <BuildOutlined className='feature-icon' />,
  //     title: 'Beyond capacity building: Design Support',
  //     description: 'Outcomes-focused learning, helping to understand and manage risk',
  //   },
  //   {
  //     icon: <RiseOutlined className='feature-icon' />,
  //     title: 'Catalysting private sector investment:',
  //     description: 'Umbits private sector investment and interest',
  //   },
  // ];

  const { t } = useTranslation();

  return (
    <section className='features-section'>
      <div className='container'>
        <h2 className='section-title'>{t('keyfeatures.keyFeaturesHeading')}</h2>

        <div className='features-grid'>
          {/* First Row */}
          <div className='feature-row'>
            <div className='feature-item'>
              <div className='icon-container'>
                <RiseOutlined />
              </div>
              <h3 className='feature-title'>{t('keyfeatures.section1Label')}</h3>
              <p className='feature-description'>{t('keyfeatures.section1Desc')}</p>
            </div>

            <div className='vertical-divider'></div>

            <div className='feature-item'>
              <div className='icon-container'>
                <UserOutlined />
              </div>
              <h3 className='feature-title'>{t('keyfeatures.section2Label')}</h3>
              <p className='feature-description'>{t('keyfeatures.section2Desc')}</p>
            </div>
          </div>

          <div className='horizontal-divider'></div>

          {/* Second Row */}
          <div className='feature-row'>
            <div className='feature-item'>
              <div className='icon-container'>
                <BuildOutlined />
              </div>
              <h3 className='feature-title'>{t('keyfeatures.section3Label')}</h3>
              <p className='feature-description'>{t('keyfeatures.section3Desc')}</p>
            </div>

            <div className='vertical-divider'></div>

            <div className='feature-item'>
              <div className='icon-container'>
                <ExperimentOutlined />
              </div>
              <h3 className='feature-title'>{t('keyfeatures.section4Label')}</h3>
              <p className='feature-description'>{t('keyfeatures.section4Desc')} </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
